import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const localTheme: ThemeApiStructure = {
  id: "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "sfi",
  display_name: "SFI",
  description: "",
  code: "",
  url_site: "/solicita_tu_credito",
  url_privacy_notice: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  url_terms_and_conditions: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  palette: {
    palette: {
      primary: {
        base: "#D9E9E1",
        dark: "#05562A", // obscuro
        main: "#0C773D", // color 2
        light: "#EAB48D", // color 1
        accent: "#DE7327", // accents
      },
      components: {
        slider: {
          rail: "#E1EFE8",
          label: "#05562A",
          track: "#0C773D",
          thumbIcon: "#DE7327",
        },
        buttonSelect: {
          textColor: "#05562A",
          backgroundColor: "#E1EFE8",
          textColorActive: "#FFFFFF",
          bordeColorActive: "#05562A",
          backgroundColorActive: "#05562A",
        },
      },
    },
    interface: {
      navbar: {
        logo: "sfi/portal/logos/logo.png",
        logo_width: 130,
        logo_height: "auto",
      },
      lateral: {
        bg_dark: "#05562A",
        bg_light: "#05562A",
        logo_bg_dark: "sfi/portal/logos/logo_white.png",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "sfi/portal/logos/logo_white.png",
        text_bg_light: "#FFFFFF",
        logo_width: 250,
        logo_height: "auto",
      },
      metadata: {
        title: "SFI",
        favicon: "sfi/portal/logos/favicon.ico",
      },
    },
  },
};

export const interfaceConfig: InterfaceConfig = {
  name: "sfi",
  interest_rate: 30,
  companyNames: ["Soluciones Financieras Internacionales S.A. de C.V. SOFOM ENR", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  home_url: "",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_Zca6CjCDk",
      userPoolClientId: "41v7gn9rlcmjr9q5572qpma5q1",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
